import { Box } from '@mui/material'
import { ShowDialogProps } from 'src/show-dialog'
import MaintenanceListView from './MaintenanceListView'

interface DailyMaintenancesDialogProps {
  onlyDaily?: boolean
}

export const DailyMaintenancesDialog: React.FC<DailyMaintenancesDialogProps & ShowDialogProps> = ({
  pop,
}) => {
  return (
    <Box data-test-id="daily-maintenance-dialog-content" sx={{ width: '100%', overflowX: 'hidden', px: { xs: 1.5, sm: 2 }, py: 1.5 }}>
      <MaintenanceListView isDialog pop={pop} />
    </Box>
  )
}
